import type { JSX } from 'react';
import type { CSSProperties, ReactNode } from 'react';

import { RADIUS, TAG_COLORS, type TagColor } from './tokens';

export interface TagProps {
  /** default / blue / orange / green / red / gold / indigo. */
  color?: TagColor;
  /** Без рамки (как тег `T` в CRM) — для плотных таблиц. */
  borderless?: boolean;
  icon?: ReactNode;
  title?: string;
  style?: CSSProperties;
  children: ReactNode;
}

/** antd-цвет («success», «processing», «volcano»…) → цвет `Tag`. */
export function tagColorOf(c: string | undefined | null): TagColor {
  if (!c) return 'default';
  if (c === 'blue' || c === 'geekblue' || c === 'processing' || c === 'cyan') return 'blue';
  if (c === 'red' || c === 'error' || c === 'magenta') return 'red';
  if (c === 'gold' || c === 'warning' || c === 'yellow') return 'gold';
  if (c === 'green' || c === 'success' || c === 'lime') return 'green';
  if (c === 'orange' || c === 'volcano') return 'orange';
  if (c === 'purple' || c === 'indigo') return 'indigo';
  return 'default';
}

/** Тег статуса/типа (порт `_ds/components/Tag`): 12/20, радиус 4. */
export function Tag({ color = 'default', borderless, icon, title, style, children }: TagProps): JSX.Element {
  const [bg, fg, bd] = TAG_COLORS[color] ?? TAG_COLORS.default;
  return (
    <span
      title={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 12,
        lineHeight: '20px',
        padding: '0 8px',
        borderRadius: RADIUS.sm,
        background: bg,
        color: fg,
        border: borderless ? '1px solid transparent' : `1px solid ${bd}`,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {icon}
      {children}
    </span>
  );
}
